import LocalizedStrings from './localized-strings';

let strings = new LocalizedStrings({
    en: {
        noUpcommingStages: 'no upcomming stages',
        news: 'news',
        partners: 'partners',
        hello: 'hello',
        about: 'about',
        stages: 'stages',
        results: 'results',
        contacts: 'contacts',
        registration: 'registration',
        participants: 'participants',
        participant: 'participant',
        stage: 'stage',
        stageInfo: 'Stage info',
        regulations: 'regulations',
        registeredSuccessfully: 'Registered successfully',
        pay: 'pay',
        timeLeft: 'Time left',
        register: 'register',
        registrationClosed: 'Registration to this stage is closed',
        paymentCanceled: 'Payment canceled',
        paymentCanceledText: 'Your payment was canceled',
        agreeOnTerms: 'Agree on terms ',
        season: 'season',
        firstName: 'First name',
        lastName: 'Last name',
        gender: 'Gender',
        email: 'Email',
        phone: 'Phone',
        friendPhone: 'Friend\'s phone',
        city: 'City',
        club: 'Club',
        payed: 'Payed',
        submit: 'Submit',
        male: 'Male',
        female: 'Female',
        selectGender: 'Select gender',
        birthDate: 'Birth date',
        edit: 'Edit',
        price: 'Price',
        distance: 'Distance',
        noStages: 'No stages',
        requiredField: 'Required field',
        invalidEmailField: 'Invalid email',


        eventEnded: 'Event ended',
        hasResults: 'Has results',
        liveResults: 'Live results',


        title: 'Title',
        date: 'Date',
        address: 'address',
        registrationEnabled: 'Registration enabled',

        isFree: 'Is free',
        childrenPrice: 'Children price',
        olderPrice: 'Older price',
        dateUntil: 'Date until',
        remove: 'Remove',
        addPrice: 'Add price',
        cancel: 'Cancel',
        noSeasons: 'No seasons',
        registeredSuccessfullyAndNeedToPay: 'You have registered successfully. You need to pay',
        registeredSuccessfullyAndGotPayment: 'You have registred successfully and we got your payment.',

        search: 'search',
        facebook: 'Facebook',
        instagram: 'Instagram',
        youtube: 'Youtube',
        logo: 'Logo',
        settingsEdit: 'Settings edit',
        settings: 'Settings',
        posts: 'Posts',
        seasons: 'Seasons',
        viewSite: 'View site',
        logout: 'Logout',
        actions: 'Actions',
        delete: 'Delete',
        preview: 'Preview',
        newPost: 'New post',
        image: 'Image',
        body: 'body',
        postEdit: 'Post edit',
        upload: 'Upload',
        loading: 'Loading',
        password: 'Password',
        eventHasEnded: 'Event has endend',
        yes: 'Yes',
        no: 'No',
        paymentPage: 'Payment page',
        newParticipant: 'New participant',
        registerToAllStages: 'Register to all stages',
        code: 'Code',
        codeHelperText: 'Code is used when matching routes while registering to all stages',
        name: 'Name',
        newStage: 'New stage',
        stageEdit: 'Stage edit',
        distanceEdit: 'Distance edit',
        newDistance: 'New distance',
        archive: 'Archive',
        marketingEmailConfirmation: 'I would like to receive marketing emails',
        publishDate: 'Publish date',
        newPartner: 'New partner',
        partnerEdit: 'Partner edit',
        link: 'Link',
        export: 'Export',
        selectStage: 'Select stage',
        participantsExport: 'Participants export',
        allParticipantsExport: 'All participants export',
        order: 'Order',
        colCount: 'Columns count',
        stageResults: 'Stage results',
        noDistances: 'No distances',
        selectDistance: 'Select distance',
        noResults: 'No results',
        selectOrDropFile: 'Select file',
        doYouWantToRemove: 'Do you want to remove?',

        insurance: 'Insurance',
        insuranceTextLabel: 'Insurance page label',
        insuranceTextInRegistration: 'Insurance checkbox text in registration',
        socialMedia: 'Social media',
        pages: 'Pages',
        insuranceText: 'Insurance text',
        insuranceEnabled: 'Insurance enabled',
        filters: 'Filters',
        income: 'Income',
        medicalConfirmation: 'I am physically ready to run the selected distance and have checked my healt in hospital',

        enLabel: 'In English',
        ltLabel: 'In Lithuanian',

        displayNews: 'Display news',
        displayPartners: 'Display partners',
        singleEventWebsite: 'Single event website',
        availableMenuItems: 'Available menu items',
        currentMenuItems: 'Current menu items',
        add: 'Add',

        title_lt: 'Title in LT',
        title_en: 'Title in EN',
        url: 'URL',
        addToMenu: 'Add to menu',
        externalRegistration: 'External website registraion',
        externalRegulationsLink: 'External regulations link',
        externalRegistrationLink: 'External registration link',
        externalParticipantsLink: 'External participants link',
        stageRegulations: 'Stage regulations',
        images: 'Images',
        newImage: 'New image',
        totalParticipants: 'Total participants',
        localizationEnabled: 'Localization enabled',
        globalResultsStage: 'Global results stage',
        globalResults: 'Global results',
        registerToCustomStages: 'Register to custom stages',
        showInMainWindow: 'Show in main window',
        country: 'Country',
        participantResultsHistory: 'Participant results history',
        startSearch: 'Search',
        participantResults: 'Participant results',
        weUsePlatform: 'We use',
        position: 'Position',
        result: 'Result',
        resultsPositionFieldValuePos: 'Which col contains position in results file',
        resultsFileInfo: 'Results file info',
        diploma: 'Diploma',
        generateDiploma: 'Generate diploma',
        diplomaBgImage: 'Diploma BG image(Encoded in base64)',
        newSeason: 'New season',
        seasonEdit: 'Season edit',
        statistics: 'Statistics',
        login: 'Login',
        siteConfig: 'Site config',
        menu: 'Menu',
        colors: 'Colors',
        menuColor: 'Menu color',
        menuHighlightColor: 'Menu Highlight Color',
        buttonColor: 'Button Color',
        buttonHoverColor: 'Button Hover Color',
        partnerCategories: 'Partner categories',
        newPartnerCategory: 'New partner category',
        partnerCategoryEdit: 'Partner category edit',
        partnerCategory: 'Partner category',
        noCategories: 'No categories',

        gdprConfirmation: 'I agree that my personal data would be collected and used.',
        gdprPageTitle: 'Personal data collection and use',
        invalidDateField: 'Invalid date',
        promoCodes: 'Promo codes',
        newPromoCode: 'New promo code',
        codesLeft: 'Codes left',
        promoCodeEdit: 'Promo code edit',
        promoCode: 'Promo code',
        discount: 'Discount',
        calculating: 'Calculating...',

        paysera: 'Paysera',
        projectId: 'Project ID',
        projectPassword: 'Project password',
        projectHeadTag: 'Project HEAD tag',
        multipleStageDisplay: 'Multiple stages display on landing',

        webKeywords: 'Web keywords',
        webDescription: 'Web description',

        tableLink: 'More',
        seasonPersonIdentifier: 'Season person identifier'
    },
    lt: {
        noUpcommingStages: 'Nėra artimiausių etapų',
        news: 'naujienos',
        partners: 'partneriai',
        hello: 'pradžia',
        about: 'apie',
        stages: 'etapai',
        results: 'rezultatai',
        contacts: 'kontaktai',
        registration: 'registracija',
        participants: 'dalyviai',
        participant: 'dalyvis',
        stage: 'etapas',
        date: 'data',
        regulations: 'nuostatai',
        registeredSuccessfully: 'Registracija sėkminga',
        pay: 'Mokėti',
        timeLeft: 'Iki starto liko',
        register: 'Registruotis',
        registrationClosed: 'Registracija uždaryta',
        paymentCanceled: 'Mokėjimas atšauktas',
        paymentCanceledText: 'Jūsų mokėjimas atšauktas',
        stageInfo: 'Etapo informacija',
        firstName: 'Vardas',
        lastName: 'Pavardė',
        gender: 'Lytis',
        email: 'El. paštas',
        phone: 'Telefonas',
        friendPhone: 'Draugo telefonas',
        city: 'Miestas',
        club: 'Klubas',
        payed: 'Apmokėta',
        submit: 'Išsaugoti',
        male: 'Vyras',
        female: 'Moteris',
        selectGender: 'Pasirinkite lytį',
        birthDate: 'Gimimo data',
        edit: 'Redaguoti',
        addPrice: 'Pridėti kainą',
        price: 'Kaina',
        noDistances: 'Nėra distancijų',
        distance: 'Distancija',
        noStages: 'Nėra etapų',
        requiredField: 'Privalomas laukas',
        invalidEmailField: 'Neteisingas el. pašto adresas',
        eventEnded: 'Renginys jau įvyko',
        agreeOnTerms: 'Susipažinau ir sutinku su renginio nuostatais',
        medicalConfirmation: 'Esu fiziškai pasiruošęs dalyvauti pasirinktoje distancijoje ir pasitikrinęs sveikatą gydymo įstaigoje',

        title: 'Pavadinimas',
        address: 'Adresas',
        registrationEnabled: 'Registracija įjungta',
        hasResults: 'Rezultatai',
        liveResults: 'Rezultatai tiesiogiai',
        isFree: 'Nemokamas',
        childrenPrice: 'Kaina vaikams',
        olderPrice: 'Kaina pensininkams',
        dateUntil: 'Data iki',
        rmeove: 'Ištrinti',
        cancel: 'Atšaukti',
        season: 'Sezonas',
        noSeasons: 'Nepasirinktas sezonas',

        registeredSuccessfullyAndNeedToPay: 'Užsiregistravote sėkmingai. Jums reikia sumokėti - ',
        registeredSuccessfullyAndGotPayment: 'Jūsų registracija sėkminga. Ačiū už jūsų mokėjimą!',
        search: 'Paieška',
        facebook: 'Facebook',
        instagram: 'Instagram',
        youtube: 'Youtube',
        logo: 'Logotipas',
        settingsEdit: 'Nustatymų redagavimas',
        settings: 'Nustatymai',
        posts: 'Naujienos',
        seasons: 'Sezonai',
        viewSite: 'Į tinklapį',
        logout: 'Atsijungti',
        actions: 'Veiksmai',
        delete: 'Pašalinti',
        preview: 'Peržiūrėti',
        newPost: 'Pridėti naujieną',
        image: 'Paveikslėlis',
        body: 'Turinys',
        postEdit: 'Naujienos redagavimas',
        upload: 'Įkelti',
        loading: 'Prašome palaukti. Kraunama....',
        password: 'Slaptažodis',
        eventHasEnded: 'Renginys jau įvyko. ',
        yes: 'Taip',
        no: 'Ne',
        paymentPage: 'Mokėjimo puslapis',
        newParticipant: 'Pridėti dalyvį',
        registerToAllStages: 'Registracija į visus etapus',
        code: 'Kodas',
        codeHelperText: 'Kodas naudojamas, etapų susiejimui, registruojantis į visus etapus.',
        name: 'Pavadinimas',
        newStage: 'Pridėti etapą',
        stageEdit: 'Etapo redagavimas',
        distanceEdit: 'Distancijos redagavimas',
        newDistance: 'Pridėti distanciją',
        archive: 'Archyvas',
        marketingEmailConfirmation: 'Noriu gauti reklaminius pranešimus',
        publishDate: 'Paskelbimo data',
        newPartner: 'Pridėti partnerį',
        partnerEdit: 'Partnerio redagavimas',
        link: 'Nuoroda',
        export: 'Eksportavimas',
        selectStage: 'Pasirinkite etapą',
        participantsExport: 'Dalyvių eksportavimas',
        order: 'Tvarka',
        colCount: 'Stulpelių skaičius',
        stageResults: 'Etapo rezultatai',
        selectDistance: 'Pasirinkite distanciją',
        noResults: 'Nėra rezultatų',
        selectOrDropFile: 'Pasirinkite bylą',
        doYouWantToRemove: 'Ar tikrai norite pašalinti?',
        insurance: 'Draudimas',
        insuranceTextLabel: 'Draudimo puslapio pavadinimas',
        insuranceTextInRegistration: 'Draudimo pasirinkimo tekstas, registracijoje',
        insuranceText: 'Draudimo tekstas',
        socialMedia: 'Socialiniai tinklai',
        pages: 'Puslapiai',
        insuranceEnabled: 'Draudimas galimas',
        allParticipantsExport: 'Visų dalyvių eksportavimas',
        filters: 'Filtrai',
        income: 'Pajamos',

        enLabel: 'Angliškai',
        ltLabel: 'Lietuviškai',

        displayNews: 'Rodyti naujienas',
        displayPartners: 'Rodyti partnerius',
        singleEventWebsite: 'Vieno renginio puslapis',
        availableMenuItems: 'Galimi meniu įrašai',
        currentMenuItems: 'Dabartiniai meniu įrašai',
        add: 'Pridėti',
        title_lt: 'Pavadinimas LT',
        title_en: 'Pavadinimas EN',
        url: 'Adresas',
        addToMenu: 'Pridėti į meniu',
        externalRegistration: 'Registracija kitame tinklapyje',
        externalRegulationsLink: 'Nuoroda į nuostatus kitame tinklapyje',
        externalRegistrationLink: 'Nuoroda į registraciją kitame tinklapyje',
        externalParticipantsLink: 'Nuoroda į dalyvius kitame tinklapyje',
        stageRegulations: 'Etapo nuostatai',
        images: 'Paveikslėliai',
        newImage: 'Naujas paveikslėlis',
        totalParticipants: 'Viso dalyvių',
        localizationEnabled: 'Įjungta dvikalbystė',
        globalResultsStage: 'Etapas skirtas rezultatų atvaizdavimui',
        globalResults: 'Bendri rezultatai',
        registerToCustomStages: 'Registracija į kelis etapus',
        showInMainWindow: 'Rodyti pradiniame lange',
        country: 'Šalis',
        participantResultsHistory: 'Dalyvių rezultatų istorija',
        startSearch: 'Ieškoti...',
        participantResults: 'Dalyvio rezultatų istorija',
        weUsePlatform: 'Mes naudojame',
        position: 'Pozicija',
        result: 'Rezultatas',
        resultsPositionFieldValuePos: 'Kuriame stulpelyje nurodoma vieta, rezultatų byloje',
        resultsFileInfo: 'Rezultatų bylos informacija',


        diploma: 'Diplomas',
        generateDiploma: 'Generuoti diplomą',
        diplomaBgImage: 'Diplomo pavaikslėlis (Užkoduotas base64)',
        newSeason: 'Naujas sezonas',

        seasonEdit: 'Sezono redagavimas',
        statistics: 'Statistika',
        login: 'Prisijungti',
        siteConfig: 'Tinklapio nustatymai',
        menu: 'Meniu',
        colors: 'Spalvos',
        menuColor: 'Meniu spalva',
        menuHighlightColor: 'Menu pažymėjimo spalva',
        buttonColor: 'Mygtuko spalva',
        buttonHoverColor: 'Mygtuko pažymėjimo spalva',
        partnerCategories: 'Partnerių kategorijos',
        newPartnerCategory: 'Nauja partnerių kategorija',
        partnerCategoryEdit: 'Partnerių kategorijos redagavimas',
        noCategories: 'Nėra kategorijų',
        partnerCategory: 'Partnerių kategorija',

        gdprConfirmation: 'Sutinku, kad mano asmens duomenys būtų tvarkomi.',
        gdprPageTitle: 'Asmens duomenų tvarkymas',
        invalidDateField: 'Neteisingas datos formatas',

        promoCodes: 'Nuolaidų kodai',
        newPromoCode: 'Pridėti nuolaidų kodą',
        codesLeft: 'Liko kodų',
        promoCodeEdit: 'Nuolaidų kodo redagavimas',
        promoCode: 'Nuolaidos kodas',
        discount: 'Nuolaida',
        calculating: 'Skaičiuojama...',

        tracking: 'Lankytojų sekimas',
        facebookPixelCode: 'Facebook pixel kodas',
        googleAnalyticsCode: 'Google analytics kodas',

        paysera: 'Paysera',
        projectId: 'Projekto ID',
        projectPassword: 'Projekto slaptažodis',
        projectHeadTag: 'Projekto HEAD žyma',

        multipleStageDisplay: 'Etapų rodymas pradiniame puslapyje',

        webKeywords: 'Tinklapio raktažodžiai',
        webDescription: 'Tinklapio aprašymas',

        tableLink: 'Daugiau',
        seasonPersonIdentifier: 'Sezono dalyvio identifikatorius'


    }
});
export default strings



// WEBPACK FOOTER //
// ./src/js/localization/strings.js